<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleCheck()"
                               style="background-color:#409EFF;color: white;margin-right: 5px;">
                        {{jzCheck?'重新检查':'结账检查'}}<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" v-if="jzCheck" @click="handleAddJz()"
                               style="background-color:#f59523;color: white">期末结账<i
                            class="el-icon-notebook-1"></i></el-button>
                </div>
                <div style="float: right;margin-right: 10px;vertical-align: middle;font-size: 19px;">
                    [本次结账会计期间：{{currZtDate}}]
                </div>
            </div>
        </div>

        <div class="leftdiv" style="float: left;width: 16%;border: 1px solid #ddd;height: 530px;padding: 20px">
            <el-timeline :reverse="false">
                <el-timeline-item v-for="(activity, index) in activities" :key="index">
                    <span v-if="activity.mouth <= ((currZtYue-1)==0?12:(currZtYue-1))" style="color: #afc3cb">{{activity.content}}</span>
                    <span v-else>{{activity.content}}</span>
                    <el-button size="mini" v-if="activity.mouth ==((currZtYue-1)==0?12:(currZtYue-1))" @click="handleAddFjz()"
                               style="color: white;float: right;border-color: #ac2925;background-color: #c9302c;">↩反结账
                    </el-button>
                </el-timeline-item>
            </el-timeline>
        </div>
        <div class="rightdiv" style="float: right;width: 83.6%;border: 1px solid #ddd;height: 530px;padding: 20px;">
            <el-collapse v-model="activeNames" @change="handleChange">

                <el-collapse-item title="➤ 凭证及财务情况检查" name="1">
                    <div>✰ 本期的凭证数：{{pzCount}} 张 <span class="dspan">√</span></div>
                    <div>✰ 财务初始余额试算平衡 <span class="dspan">√</span></div>
                </el-collapse-item>

                <el-collapse-item title="➤ 凭证断号及序时检查" name="2">
                    <div v-if="!pzDh">✰ 本期凭证断号检查 <span class="dspan">√</span></div>
                    <div v-if="pzDh">
                        ✰ <span style="color: red;">凭证存在断号！</span>
                        <span style="float: right">
                            <el-button size="mini" type="warning" style="margin-right: 50px;" @click="yjlh()" plain>一键连号</el-button>
                            <span style="color: red;font-size: 17px;padding-right: 50px;">✖</span>
                        </span>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="➤ 资产及损益结转检查" name="3">
                    <div>✰ 计提折旧已完成 <span class="dspan">√</span></div>
                    <div v-if="syjz">
                        ✰ <span style="color: red">损益结转未完成，请处理</span>
                        <span style="float: right">
                            <el-button size="mini" type="warning" style="margin-right: 50px;" @click="jzsy()" plain>损益结转</el-button>
                            <span style="color: red;font-size: 17px;padding-right: 50px;">✖</span>
                        </span>
                    </div>
                    <div v-if="!syjz">✰ 损益结转已完成 <span class="dspan">√</span></div>
                </el-collapse-item>

            </el-collapse>
        </div>

    </div>
</template>
<script>

    export default {
        inject:['reload'],
        name: 'jieZhangList',
        data() {
            return {
                activities: [{
                    content: '1月',
                    mouth: 1
                }, {
                    content: '2月',
                    mouth: 2
                }, {
                    content: '3月',
                    mouth: 3
                }, {
                    content: '4月',
                    mouth: 4
                }, {
                    content: '5月',
                    mouth: 5
                }, {
                    content: '6月',
                    mouth: 6
                }, {
                    content: '7月',
                    mouth: 7
                }, {
                    content: '8月',
                    mouth: 8
                }, {
                    content: '9月',
                    mouth: 9
                }, {
                    content: '10月',
                    mouth: 10
                }, {
                    content: '11月',
                    mouth: 11
                }, {
                    content: '12月',
                    mouth: 12
                }],
                activeNames: [],
                jzCheck: false,
                pzCount: 0,
                pzDh: false,
                syjz: false,
                pzDhMsg: ''
            }
        },
        computed: {
            currZtDate: {
                get() {
                    let date = localStorage.getItem('CURR_ZT_DATE');
                    if (date != null) {
                        return date.replace("期", "月");
                    }
                    return "请先选择账套！"
                }
            },
            currZtYue: {
                get() {
                    let yue = localStorage.getItem('CURR_ZT_DATE');
                    if (yue != null) {
                        return parseInt(yue.substring(5, 7).replace("期", ""));
                    }
                    return 99;
                }
            },
            currZtNian: {
                get() {
                    let nian = localStorage.getItem('CURR_ZT_DATE');
                    if (nian != null) {
                        return parseInt(nian.substring(0, 4));
                    }
                    return 99;
                }
            }
        },
        methods: {
            handleChange() {
                if (!this.jzCheck) {
                    this.activeNames = [];
                }
            },
            handleCheck() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/jieZhang/jzCheck'),
                    method: 'post',
                    data: {
                        "zhangTaoId": localStorage.getItem('CURR_ZT_ID'),
                        "jzYear": this.currZtNian,
                        "jzMonth": this.currZtYue
                    }
                }).then(res => {
                    if (res.data.code == 0) {

                        this.pzCount = res.data.data.pzCount;
                        this.pzDh = res.data.data.pzDh;
                        this.pzDhMsg = res.data.data.pzDhMsg;

                        this.syjz = res.data.data.syjz;

                        if(!this.pzDh && !this.syjz){
                            this.jzCheck = true;
                        }else{
                            this.jzCheck = false;
                        }

                        this.activeNames = ['1', '2', '3']

                        this.$notify({
                            title: '检查完成',
                            type: 'success',
                            position: 'bottom-right'
                        });

                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            handleAddJz() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/jieZhang/jz'),
                    method: 'post',
                    data: {
                        "zhangTaoId": localStorage.getItem('CURR_ZT_ID'),
                        "jzYear": this.currZtNian,
                        "jzMonth": this.currZtYue
                    }
                }).then(res => {
                    if (res.data.code == 0) {

                        localStorage.setItem('CURR_ZT_ID', res.data.data.currZt.id);
                        localStorage.setItem('CURR_ZT_NAME', res.data.data.currZt.qymc);
                        localStorage.setItem('CURR_ZT_DATE', res.data.data.currJz.jzYear+"年"+res.data.data.currJz.jzMonth+"期");

                        this.reload();

                        this.$notify({
                            title: '期末结账成功！',
                            type: 'success',
                            offset: 600
                        });

                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            handleAddFjz() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/jieZhang/fjz'),
                    method: 'post',
                    data: {
                        "zhangTaoId": localStorage.getItem('CURR_ZT_ID'),
                        "jzYear": this.currZtNian,
                        "jzMonth": this.currZtYue
                    }
                }).then(res => {
                    if (res.data.code == 0) {

                        localStorage.setItem('CURR_ZT_ID', res.data.data.currZt.id);
                        localStorage.setItem('CURR_ZT_NAME', res.data.data.currZt.qymc);
                        localStorage.setItem('CURR_ZT_DATE', res.data.data.currJz.jzYear+"年"+res.data.data.currJz.jzMonth+"期");

                        this.$notify({
                            title: '反结账成功！',
                            type: 'success',
                            offset: 600
                        });

                        this.reload();

                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            jzsy(){
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/syjz'),
                    method: 'post',
                    data: {}
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCheck();
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {})
            },
            yjlh(){
                this.$confirm('将本账期凭证重新连号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/pingZheng/oneKeyPzPx'),
                        method: 'post',
                        data: {}
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCheck();
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    }).finally(r => {})
                }).catch(() => {});
            }
        },
        created: function () {

        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .leftdiv >>> .el-timeline-item__timestamp.is-bottom {
        margin-top: 2px !important;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    .dspan {
        color: #25ff46;
        float: right;
        padding-right: 50px;
        font-size: 17px;
    }

    .dspanX {
        color: #f5313c;
        float: right;
        padding-right: 50px;
        font-size: 17px;
    }

    .rightdiv >>> .el-collapse-item__arrow.el-icon-arrow-right {
        display: none;
    }

    .rightdiv >>> .el-button--mini{
        padding: 5px 10px!important;
    }
</style>